import React from "react";
import cn from "classnames";
import Slider from "react-slick";
import Icon from "../../../components/Icon";
import ScrollParallax from "../../../components/ScrollParallax";
import styles from "./Journey.module.sass";

const items = [
  {
    title: "Longevity for All",
    image: "/images/zova/journey-01.jpg",
    image2x: "/images/zova/journey-01@2x.jpg",
    content: "Premium health, not premium prices. Start free with our questionnaire, then go all-in for 90 GBP—no subscriptions, no nonsense.",
  },
  {
    title: "Practical Wins Over Perfection",
    image: "/images/zova/journey-02.jpg",
    image2x: "/images/zova/journey-02@2x.jpg",
    content: "Small, science-backed changes that fit your life—like a morning stretch or a hydration boost. It’s about results, not rigid rules.",
  },
  {
    title: "Built Around You",
    image: "/images/zova/journey-03.jpg",
    image2x: "/images/zova/journey-03@2x.jpg",
    content: "From your free snapshot to your full plan, it’s all personalized. Rana nailed it: “tailored just for me.”",
  },
  {
    title: "Science You Can Lean On",
    image: "/images/zova/journey-04.jpg",
    image2x: "/images/zova/journey-04@2x.jpg",
    content: "Our medical team’s obsessed with evidence—think sleep optimization and metabolic hacks straight from the latest research.",
  },
  {
    title: "Your Team, Your Pace",
    image: "/images/zova/journey-05.jpg",
    image2x: "/images/zova/journey-05@2x.jpg",
    content: "We guide, not push. For 3 months, we’ve got your back to make it work, your way.",
  },
];

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Journey = () => {
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={cn("section", styles.section, styles.journey)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.wrapper}>
          <div className={styles.wrap}>
            <Slider className="journey-slider" {...settings}>
              {items.map((x, index) => (
                <ScrollParallax className={styles.slide} key={index}>
                  <div className={styles.preview}>
                    <img
                      srcSet={`${x.image2x} 2x`}
                      src={x.image}
                      alt={x.title}
                    />
                  </div>
                  <div className={styles.subtitle}>{x.title}</div>
                  <div className={styles.content}>{x.content}</div>
                </ScrollParallax>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Journey;
